import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class Team extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'team section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'team-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: ['Meet our team'],
      paragraph: 'Our team works remotely from a range of different countries around the world.'
    };

    return (
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader
              data={sectionHeader}
              className="center-content reveal-from-bottom"
            />
            <div className={tilesClasses}>
              <div
                className="tiles-item reveal-from-bottom"
                data-reveal-delay="200"
              >
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require("./../../assets/images/harry_devane.jpg")}
                        alt="Team member 02"
                        width={180}
                        height={180}
                      />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">Harry Devane</h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      Founder
                    </div>
                    <p className="m-0 text-sm">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gridGap: "10px",
                        }}
                      >
                        <div>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              fill: "#548CFF",
                            }}
                          >
                            <title>Twitter</title>
                            <path d="M12.6 1.5h2.5l-5.4 6.2 6.4 8.5h-5l-3.9-5.1-4.5 5.1H.2l5.8-6.6L0 1.5h5.1l3.5 4.7 4-4.7zm-.9 13.2h1.4L4.4 2.9H2.9l8.8 11.8z" />
                          </svg>
                        </div>
                        <div>
                          <a
                            href="https://x.com/harrydevane"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#548CFF",
                            }}
                          >
                            @harrydevane
                          </a>
                        </div>
                      </div>
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="tiles-item reveal-from-bottom"
                data-reveal-delay="200"
              >
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require("./../../assets/images/camden_cove.jpg")}
                        alt="Team member 02"
                        width={180}
                        height={180}
                      />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">Camden Cove</h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      Software Engineer
                    </div>
                    <p className="m-0 text-sm">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gridGap: "10px",
                        }}
                      >
                        <div>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              fill: "#548CFF",
                            }}
                          >
                            <title>Twitter</title>
                            <path d="M12.6 1.5h2.5l-5.4 6.2 6.4 8.5h-5l-3.9-5.1-4.5 5.1H.2l5.8-6.6L0 1.5h5.1l3.5 4.7 4-4.7zm-.9 13.2h1.4L4.4 2.9H2.9l8.8 11.8z" />
                          </svg>
                        </div>
                        <div>
                          <a
                            href="https://x.com/camdenc_"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#548CFF",
                            }}
                          >
                            @camdenc_
                          </a>
                        </div>
                      </div>
                    </p>
                  </div>
                </div>
              </div>

              <div
                className="tiles-item reveal-from-bottom"
                data-reveal-delay="200"
              >
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require("./../../assets/images/michele_coco.jpeg")}
                        alt="Team member 02"
                        width={180}
                        height={180}
                      />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">Michele Coco</h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      Software Engineer
                    </div>
                    {/* <p className="m-0 text-sm">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gridGap: "10px",
                        }}
                      >
                        <div>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              fill: "#548CFF",
                            }}
                          >
                            <title>Twitter</title>
                            <path d="M12.6 1.5h2.5l-5.4 6.2 6.4 8.5h-5l-3.9-5.1-4.5 5.1H.2l5.8-6.6L0 1.5h5.1l3.5 4.7 4-4.7zm-.9 13.2h1.4L4.4 2.9H2.9l8.8 11.8z" />
                          </svg>
                        </div>
                        <div>
                          <a
                            href="https://x.com/camdenc_"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#548CFF",
                            }}
                          >
                            @camdenc_
                          </a>
                        </div>
                      </div>
                    </p> */}
                  </div>
                </div>
              </div>

              <div
                className="tiles-item reveal-from-bottom"
                data-reveal-delay="200"
              >
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require("./../../assets/images/andrew_martinez.png")}
                        alt="Andrew Martinez"
                        width={180}
                        height={180}
                      />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">Andrew Martinez</h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      Software Engineer
                    </div>
                    {/* <p className="m-0 text-sm">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gridGap: "10px",
                        }}
                      >
                        <div>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              fill: "#548CFF",
                            }}
                          >
                            <title>Twitter</title>
                            <path d="M12.6 1.5h2.5l-5.4 6.2 6.4 8.5h-5l-3.9-5.1-4.5 5.1H.2l5.8-6.6L0 1.5h5.1l3.5 4.7 4-4.7zm-.9 13.2h1.4L4.4 2.9H2.9l8.8 11.8z" />
                          </svg>
                        </div>
                        <div>
                          <a
                            href="https://x.com/camdenc_"
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "#548CFF",
                            }}
                          >
                            @camdenc_
                          </a>
                        </div>
                      </div>
                    </p> */}
                  </div>
                </div>
              </div>

              {/* <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/team-member-04.jpg')}
                        alt="Team member 04"
                        width={180}
                        height={180} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Marika Savitskiy
                    </h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      CEO & Co-Founder
                    </div>
                    <p className="m-0 text-sm">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/team-member-05.jpg')}
                        alt="Team member 05"
                        width={180}
                        height={180} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Marika Savitskiy
                    </h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      CEO & Co-Founder
                    </div>
                    <p className="m-0 text-sm">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
                <div className="tiles-item-inner">
                  <div className="team-item-header">
                    <div className="team-item-image mb-24">
                      <Image
                        src={require('./../../assets/images/team-member-06.jpg')}
                        alt="Team member 06"
                        width={180}
                        height={180} />
                    </div>
                  </div>
                  <div className="team-item-content">
                    <h5 className="team-item-name mt-0 mb-4">
                      Marika Savitskiy
                    </h5>
                    <div className="team-item-role text-xxs fw-500 tt-u text-color-primary mb-8">
                      CEO & Co-Founder
                    </div>
                    <p className="m-0 text-sm">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.
                    </p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Team.propTypes = propTypes;
Team.defaultProps = defaultProps;

export default Team;
